// スライドサムネイル
var swiperThumbnail = new Swiper(".swiperThumbnail", {
    slidesPerView: 2,
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
    grid: {
        rows: 11,
        fill: 'row',
    },
    breakpoints: {
        990: {
            slidesPerView: 6,
            grid: {
                rows: 4,
            }
        }
    }
});

var swiperMain = new Swiper(".swiperMain", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiperThumbnail,
    },
});
